import script from "./CallInfoRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./CallInfoRow.vue?vue&type=script&setup=true&lang=ts"

import "./CallInfoRow.vue?vue&type=style&index=0&id=65271b72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65271b72"]])

export default __exports__